const MONTH_COUNT = 6;
const MONTHS = [
    {
      id: 1,
      text: 'January',
    },
    {
      id: 2,
      text: 'February',
    },
    {
      id: 3,
      text: 'March',
    },
    {
      id: 4,
      text: 'April',
    },
    {
      id: 5,
      text: 'May',
    },
    {
      id: 6,
      text: 'June',
    },
    {
      id: 7,
      text: 'July',
    },
    {
      id: 8,
      text: 'August',
    },
    {
      id: 9,
      text: 'September',
    },
    {
      id: 10,
      text: 'October',
    },
    {
      id: 11,
      text: 'November',
    },
    {
      id: 12,
      text: 'December',
    },
];

export function useCalendarMonthGetter() {
  const currentMonth = new Date().getMonth() + 1;
  const currentIndexMonth = currentMonth - 1;
  const existingMonth = MONTHS.slice(currentIndexMonth).map((item) => {
    return {
      ...item,
      year: new Date().getFullYear(),
    };
  });
  const plusMonth = MONTHS.slice(0, MONTH_COUNT - existingMonth.length).map((item) => {
    return {
      ...item,
      year: new Date().getFullYear() + 1,
    };
  });
  const finalMonth = [...existingMonth, ...plusMonth];
  const monthArray = MONTHS.slice(currentIndexMonth, currentIndexMonth + MONTH_COUNT).map((item) => {
    return {
      ...item,
      year: new Date().getFullYear(),
    };
  });

  const resultMonth = currentMonth < 8 ? monthArray : finalMonth;

  return { month: resultMonth };
}
